import { Box, Stack, Typography } from '@mui/material';
import { NoDataFound2 } from 'Components';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';

export const NoDisabilityConfirmations = () => {
  const isDesktop = useIsDesktop();
  const dictionary = useDictionary(Dictionary, DICTIONARY.DisabilityApprovals);
  return (
    <Box mt={isDesktop ? '56px' : '32px'}>
      <NoDataFound2
        gap={isDesktop ? '48px' : '32px'}
        headerComponent={
          <Stack gap='8px' alignItems={'center'}>
            <Typography
              variant='h2'
              color='text.secondary'
              alignSelf={'center'}
              tabIndex={0}
              component='h1'
            >
              {dictionary.title}
            </Typography>
            <Stack
              justifyContent={'center'}
              alignItems={'center'}
              direction={isDesktop ? 'row' : 'column'}
              marginBottom={isDesktop ? '20px' : undefined}
            >
              <Typography
                variant='body1'
                color='text.secondary'
                marginRight={'5px'}
              >
                {dictionary.noData.labels.title}
              </Typography>
              <Typography variant={'body3'} color='text.secondary'>
                {dictionary.noData.labels.subTitle}
              </Typography>
            </Stack>
          </Stack>
        }
        redirects={dictionary.noData.redirects}
      />
    </Box>
  );
};
